import BaseEntity from "./BaseEntity";

export default class TSEnumerationLocale extends BaseEntity {
  Local = "";
  Text = "";
}
